export default __webpack_public_path__ + "static/media/InterTrackLogo.e7259c7f.svg";